// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/" + (chunkId === 179 ? "main" : chunkId) + "." + {"179":"c7634d27","356":"4f5aa62c","521":"0a791032","662":"6b5a1236"}[chunkId] + ".css";
};